<template>
  <div class="home">
    <div class="banner-box">
      <div class="swiper-pagination"></div>
      <div v-if="$store.state.sceneClassName !== 'app'" class="channelAdvantage btnNext">
        <div class="iconfont iconarrow-right"></div>
      </div>
      <div v-if="$store.state.sceneClassName !== 'app'" class="channelAdvantage btnPrev">
        <div class="iconfont iconjiantou-copy"></div>
      </div>
      <swiper class="big-swiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in banners" :key="index">
          <div class="swiper-item" :style="{
            backgroundImage: `url(${$store.state.sceneClassName === 'app' ? item.appImg : item.img
              })`
          }">
            <div class="lz-banner3 w1200 EC5">
              <div :class="`title T1 mb8 ${item.isBig && 'big_title'}`" v-html="item.title"></div>
              <p class="T5 mb64">{{ item.desc }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- <swiper class="thumbs-swiper" :options="thumbsSwiperOptions">
        <swiper-slide v-for="(item, index) in banners" :key="index">
          <div
            class="thumbs-swiper-item"
            :style="{
              backgroundImage: `url(${item.img})`,
            }"
          ></div>
        </swiper-slide>
      </swiper> -->
    </div>
    <div class="data-box">
      <div :class="$store.state.sceneClassName === 'app'
          ? 'data-list-top'
          : 'data-list w1200'
        ">
        <div class="data-item">
          <div class="data-item_content">终端用户数</div>
          <div class="data-text"><span class="data">1000w</span> +</div>
        </div>
        <div class="data-item">
          <div class="data-item_content">同时在线人数</div>
          <div class="data-text"><span class="data">100w</span> +</div>
        </div>
        <div class="data-item">
          <div class="data-item_content">合作伙伴</div>
          <div class="data-text"><span class="data">1000</span> +</div>
        </div>
        <div class="data-item">
          <div class="data-item_content">曝光量</div>
          <div class="data-text">
            <span class="data">10000w</span> +
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Free from "@/components/Free";
import Channel from "@/components/Channel";
import CaseList from "@/components/CaseList";
import SwiperCore, { Thumbs, Navigation, Autoplay, Pagination } from "swiper";
import {
  banners,
  moduleCard,
  moduleLink,
  modulePlan,
  moduleEffect,
  moduleChoice
} from "./data.js";
import XRouterLink from "../../components/XRouterLink.vue";
SwiperCore.use([Thumbs, Navigation, Autoplay, Pagination]);
export default {
  name: "home",
  data() {
    return {
      banners,
      activeModuleCard: 1,
      moduleCard,
      moduleLink,
      modulePlan,
      activeModulePlan: 0,
      moduleEffect,
      thumbsSwiperOptions: {
        spaceBetween: 10,
        slidesPerView: 2,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
      },
      swiperOptions: {
        loop: true,
        // autoplay: {
        //   delay: 8000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        speed: 1500,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".channelAdvantage.btnNext",
          prevEl: ".channelAdvantage.btnPrev"
        }
        // 缩略图
        // autoplay: {
        //   delay: 8000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false
        // },
        // speed: 1000,
        // thumbs: { swiper: { el: '.thumbs-swiper' } }
      },
      moduleChoice,
      choiceSwiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      choiceSwiperActiveIndex: 0
    };
  },
  components: {
    "v-free": Free,
    "v-channel": Channel,
    "v-case-list": CaseList,
    "x-router-link": XRouterLink
  },
  mounted() {
    this.$store.commit("toggleH5HeaderClassName", "mNav-transparent");
  },
  methods: {
    moduleCardOver(index) {
      this.activeModuleCard = index;
    },
    modulePlanOver(index) {
      this.activeModulePlan = index;
    },
    onSlideChange({ activeIndex }) {
      this.choiceSwiperActiveIndex = activeIndex;
    }
  }
};
</script>

<style lang="scss">
.home {
  .banner-box {
    position: relative;

    &:hover {
      .channelAdvantage {
        display: block;
      }
    }

    .swiper-pagination {
      bottom: 10px;
      left: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #fff;
        border-radius: 4px;
        opacity: 0.5;
        margin: 0 5px;
      }

      .swiper-pagination-bullet-active {
        width: 32px;
        background: #fff;
        border-radius: 4px;
        opacity: 1;
      }
    }

    .channelAdvantage {
      display: none;
      position: absolute;
      width: 64px;
      height: 64px;
      top: 50%;
      margin-top: -25px;
      z-index: 2;
      outline: 0;
      cursor: pointer;
      font-size: 20px;
      text-align: center;
      line-height: 50px;

      &.btnNext {
        right: 64px;
      }

      &.btnPrev {
        left: 64px;
      }

      div {
        height: 50px;
        line-height: 50px;
        font-size: 30px;
        color: #ffffff;
      }
    }

    .big-swiper {
      height: 640px;

      .swiper-item {
        min-width: 1200px;
        height: 640px;
        overflow: hidden;
        background-position: center;
        background-size: auto 640px;
      }
    }

    .thumbs-swiper {
      position: absolute;
      bottom: 0;
      right: 2%;
      transform: translateX(-50%);
      box-sizing: border-box;
      padding: 10px 0;
      z-index: 2;

      .swiper-slide {
        width: 60px !important;
        height: 40px;
        cursor: pointer;

        .thumbs-swiper-item {
          width: 100%;
          height: 100%;
          background-size: cover;
          border-radius: 4px;
        }
      }
    }
  }

  .data-box {
    background: #f6faff;
    color: #1472ff;

    .data-list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 60px;
      height: 120px;

      .data-text {
        display: flex;
        align-items: center;
        font-size: 24px;

        .data {
          font-size: 40px;
          font-weight: 600;
          padding-bottom: 7px;
          margin-right: 4px;
        }

        .small-font {
          font-size: 16px;
          padding-top: 10px;
        }
      }

      .data-item_content {
        font-size: 14px;
      }
    }
  }

  .module-flow-box {
    img {
      max-width: 1168px;
      margin-top: 64px;
    }
  }

  .module-card-box {
    height: 809px;

    .box {
      display: flex;
      justify-content: center;
      width: 100%;
      max-width: 1920px;
      margin: 0 auto;
      text-align: center;

      .active.item {
        flex: 2;
      }

      .active.item img {
        max-width: 480px;
      }
    }

    .item {
      flex: 1;
      height: 809px;
      padding-top: 96px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      overflow: hidden;
      transition: all 0.2s;

      .name {
        font-size: 36px;
        font-weight: 500;
      }

      .text {
        font-size: 16px;
        line-height: 24px;
        max-width: 366px;
        padding: 16px 16px 72px;
        margin: 0 auto;
      }

      .link-box {
        padding-bottom: 60px;

        a {
          font-size: 16px;
          font-weight: 500;
          color: #fff;
        }
      }

      img {
        margin-top: 10px;
        max-width: 480px;
      }

      &:nth-child(1) {
        background: #ffa114;
      }

      &:nth-child(2) {
        background: #1472ff;
      }

      &:nth-child(3) {
        background: #1db85b;
      }
    }
  }

  .module-link-box {
    padding-bottom: 72px;

    .items-box {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      margin: 56px auto 0;

      .single {
        padding-left: 31px;
        flex: 1;
        text-align: left;
        border-right: 1px solid #eee;

        &:last-child {
          border-right: none;
        }

        .title {
          font-size: 24px;
          font-weight: 600;
          color: #333;
          padding-bottom: 40px;
        }

        .item {
          display: flex;
          align-items: flex-start;
          margin-top: 40px;

          &:first-of-type {
            margin-top: 0;
          }

          img {
            width: 32px;
          }

          div {
            padding-left: 12px;

            .name {
              font-size: 16px;
              font-weight: 600;
              color: #333;
            }

            .des {
              font-size: 14px;
              color: #999;
              padding-top: 4px;
            }
          }
        }
      }
    }
  }

  .module-plan-box {
    .box {
      display: flex;
      padding-top: 64px;

      .tabs {
        width: 300px;

        .main-tab {
          height: 160px;
          margin-bottom: 10px;
          border-radius: 8px;
          border: 1px solid #eee;
          text-align: left;
          padding: 28px 0 0 40px;
          cursor: pointer;

          .name {
            font-size: 24px;
            font-weight: 600;
          }

          .text {
            font-size: 16px;
            padding: 8px 0 16px;
          }

          a {
            display: none;
            font-size: 16px;
            font-weight: 600;
            color: #1472ff;
          }
        }

        .active {
          background: url("~@/assets/images/planBack.png") no-repeat rgba(20, 114, 255, 0.04);
          background-size: cover;
          border: 1px solid #1472ff;

          a {
            display: inline-block;
          }
        }
      }

      .content {
        flex: 1;

        img {
          max-width: 100%;
        }
      }
    }
  }

  .module-service-box {
    .icon-text {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 12px;

      img {
        width: 56px;
      }

      div {
        padding-left: 16px;
        max-width: 280px;
      }
    }

    .top {
      display: flex;
      padding: 52px 0 64px;
      text-align: left;
      border-bottom: 1px solid #eee;

      .right {
        position: relative;
        width: 760px;
        padding: 24px 33px;
        margin-left: 46px;
        font-size: 20px;
        line-height: 28px;
        background: #f0f9ff;
        border-radius: 18px;

        &::before {
          content: "";
          position: absolute;
          left: -9px;
          top: 30px;
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-right: 10px solid #f0f9ff;
        }
      }
    }

    .bottom {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      padding-top: 63px;
      text-align: left;

      .icon-text {
        margin-right: 32px;

        div {
          max-width: 292px;
        }
      }
    }
  }

  .data-content {
    background: #1472ff;
    background-size: 100%;
    text-align: center;
    margin: 0;
    overflow: hidden;
    color: #fff;

    .data-title {
      font-size: 36px;
      margin-bottom: 64px;
    }

    .data-tip {
      margin-bottom: 10px;
      font-size: 14px;
    }

    .data-list {
      display: flex;
      padding: 0 140px;
      justify-content: space-between;
      margin-bottom: 16px;

      .data-item {
        text-align: left;

        .data-text {
          font-size: 24px;
        }

        .data-text .data {
          font-size: 40px;
          font-weight: 600;
        }

        hr {
          width: 50px;
          height: 2px;
          margin: 5px auto 20px;
          background: #fff;
        }

        .data-item_content {
          font-size: 14px;
        }
      }
    }

    .title-icon {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      padding: 66px 100px 96px;

      .icon-item {
        width: 20%;
        margin-bottom: 16px;
        text-align: center;

        img {
          width: 48px;
        }

        p {
          font-size: 16px;
          color: #fff;
          line-height: 40px;
        }
      }
    }
  }

  .module-choice-box {
    position: relative;
    padding-bottom: 48px;
    background: #f6faff;

    .choice-swiper {
      position: relative;
      width: 1168px;
      margin: 48px auto 0;

      .item {
        position: relative;
        width: 368px;
        height: 400px;
        padding: 48px 48px 0;
        background: #fff;
        border-radius: 8px;
        text-align: left;

        .text {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
        }

        .icon-img {
          position: absolute;
          left: 16px;
          top: 24px;
        }

        .bottom {
          position: absolute;
          bottom: 24px;
          left: 50%;
          transform: translateX(-50%);
          text-align: center;

          .name {
            font-size: 16px;
            font-weight: 600;
            padding-bottom: 16px;
          }

          .img-box {
            position: relative;
            height: 72px;

            img {
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              max-height: 100%;
            }
          }
        }
      }

      .swiper-mask {

        .next-mask,
        .prev-mask {
          position: absolute;
          bottom: 10px;
          z-index: 1;
          margin: 0 auto;
          width: 50px;
          height: 400px;
          background: #f6faff;
          -webkit-box-shadow: 0 0 20px 20px #f6faff;
          box-shadow: 0 0 20px 20px #f6faff;
        }

        .next-mask {
          left: 0;
          right: -1134px;
        }

        .prev-mask {
          left: -15px;
          right: 1142px;
        }
      }

      .swiper-btn {
        position: absolute;
        bottom: 50%;
        margin: 0 auto;
        width: 1168px;
        z-index: 2;

        .swiper-button-next,
        .swiper-button-prev {
          cursor: pointer;
          background: 0 0;
          margin-top: 0;
          z-index: 6;
        }

        .swiper-button-next::after,
        .swiper-button-prev::after {
          font-size: 18px;
          font-weight: bold;
        }

        .swiper-button-next {
          right: 0;
        }
      }
    }
  }
}

.ability-business {
  .ability-banner-wrapper {
    position: relative;
    padding-top: 218px;
    height: 640px;
    width: 100%;
    color: #fff;
    background-color: #1472ff;
    background-image: url("~@/assets/images/ability1.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 640px;
  }

  .ability-banner-wrapper .ability-banner-area h1 {
    margin-bottom: 32px;
    font-size: 64px;
    line-height: 72px;
    font-weight: 600;
  }

  .ability-banner-wrapper .ability-banner-area p {
    margin-bottom: 72px;
    font-size: 20px;
    font-weight: 400;
    line-height: 28px;
    width: 400px;
  }

  .ability-banner-wrapper .ability-banner-area a {
    display: block;
    width: 144px;
    height: 44px;
    line-height: 44px;
    background: #fff;
    border-radius: 22px;
    color: #1472ff;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
  }

  .ability-banner-wrapper .ability-banner-area a:hover {
    background: #3d91ff;
    color: #fff;
  }

  .ability-banner-wrapper .ability-banner-area a:active {
    background: #1159d6;
    color: #fff;
  }

  .ability-bg_blue,
  .ability-block-item:nth-child(2n) {
    background-color: #f7fafe;
  }

  .class-room .bd img {
    width: 825px;
  }

  .pay-knowledge-img {
    width: 1225px;
  }

  .ability-block-item .reverse {
    flex-direction: row-reverse;
  }

  .ability-block-item .ability-block {
    align-items: center;
    height: 692px;
  }

  .ability-block-item .ability-block .ability-block-text {
    width: 468px;
  }

  .ability-block-item .ability-block .ability-block-text h1 {
    margin-bottom: 24px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }

  .ability-block-item .ability-block .ability-block-text .mg80 {
    margin-bottom: 80px;
  }

  .ability-block-item .ability-block .ability-block-text h6 {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
  }

  .ability-block-item .ability-block .ability-block-text p {
    line-height: 24px;
    font-size: 16px;
    font-weight: 400;
    text-align: justify;
  }

  .ability-block-item .ability-block .ability-block-img {
    width: 668px;
  }

  .ability-block-item .ability-block,
  .three-arrow {
    justify-content: space-between;
    display: flex;
  }

  .mg {
    margin-top: 12px;
  }

  .ability-bg_blue,
  .ability-block-item:nth-child(2n) {
    background-color: #f7fafe;
  }

  .ability-block-advantage .advantage-item,
  .ability-block-advantage .ct-eva-content {
    background: #fff;
    -webkit-box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04),
      0 0 20px 0 rgba(0, 0, 0, 0.03);
    box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.04), 0 0 20px 0 rgba(0, 0, 0, 0.03);
    border-radius: 8px;
  }

  .ability-block-advantage {
    padding: 96px 0;
  }

  .ability-block-advantage .advantage-title {
    margin-bottom: 64px;
    font-size: 36px;
    font-weight: 500;
    color: #333;
    line-height: 44px;
  }

  .ability-block-advantage .advantage-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .ability-block-advantage .advantage-item {
    padding: 40px 16px;
    width: 268px;
    height: 364px;
    margin-left: 32px;
    text-align: center;
  }

  .ability-block-advantage .advantage-item:first-child {
    margin-left: 0;
  }

  .ability-block-advantage .advantage-item img {
    margin-bottom: 24px;
    width: 176px;
    height: 176px;
  }

  .ability-block-advantage .advantage-item h6 {
    margin-bottom: 8px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    line-height: 28px;
  }

  .ability-block-advantage .advantage-item p {
    font-size: 16px;
    font-weight: 400;
    color: #666;
    line-height: 24px;
  }

  .ability-block-advantage .ct-eva-title {
    margin-top: 64px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    line-height: 36px;
  }

  .ability-block-advantage .ct-eva-content {
    margin-top: 32px;
    width: 1168px;
    height: 140px;
    padding-left: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .ability-block-advantage .ct-eva-content img {
    width: 140px;
    height: 140px;
  }

  .ability-block-advantage .eva-description {
    margin-left: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-top: 24px;
    color: #333;
  }

  .ability-block-advantage .eva-desc-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }

  .ability-block-advantage .eva-desc-content {
    margin-top: 8px;
    width: 976px;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .ability-block-advantage,
  .flex-column-center {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .case-list {
    background-color: #ffffff;
  }
}

.app .ability-business {
  padding-top: 1.04rem;

  .ability-banner-wrapper {
    height: 8.64rem;
    background-color: #1472ff;
    background-image: url("~@/assets/images/ability1_app.png");
    background-position: center;
    background-position-y: -0.96rem;
    background-size: cover;
    padding: 0.96rem 0.32rem 0;

    .ability-banner-area {
      text-align: center;

      h1 {
        margin-bottom: 0;
        font-size: 0.8rem;
        font-weight: 600;
        line-height: 0.88rem;
      }

      p {
        margin: 0.24rem auto 0;
        font-size: 0.32rem;
        font-weight: 400;
        line-height: 0.48rem;
        width: 5.6rem;
      }

      a {
        border: none;
        outline: 0;
        margin: 0.48rem auto 0;
        width: 3.2rem;
        height: 0.8rem;
        border-radius: 0.88rem;
        font-size: 0.32rem;
        font-weight: 500;
        line-height: 0.8rem;
      }
    }
  }

  .ability-block-item .ability-block,
  .three-arrow {
    display: block;
  }

  .ability-block-item .ability-block {
    height: auto;
    padding: 1.28rem 0.32rem;

    .ability-block-text {
      width: auto;

      h1 {
        font-size: 0.56rem;
        line-height: 0.72rem;
      }

      p {
        margin-top: 0.32rem;
        font-size: 0.28rem;
        line-height: 0.44rem;
      }
    }

    .ability-block-img {
      margin-top: 0.64rem;
      width: 100%;
    }
  }

  .ability-block-advantage {
    padding: 1.28rem 0.32rem;

    .advantage-title {
      font-size: 0.56rem;
      line-height: 0.72rem;
      margin-bottom: 0.96rem;
    }

    .advantage-list {
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .advantage-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0;
      width: 3.28rem;
      height: 5.56rem;
      border-radius: 0.16rem;
      margin-left: 0;

      h6 {
        height: 0.48rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #333;
        line-height: 0.48rem;
        margin-top: 0.32rem;
        margin-bottom: 0;
      }

      p {
        width: 2.32rem;
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #666;
        line-height: 0.44rem;
        height: 1.32rem;
      }

      img {
        width: 2.32rem;
        height: 2.32rem;
        margin: 0;
      }

      &:nth-child(n + 3) {
        margin-top: 0.96rem;
      }
    }
  }

  .case-list {
    background: #ffffff;
    padding-bottom: 0;
  }

  .ct-eva-box {
    padding: 0 0.32rem 1.12rem;
    background: #ffffff;

    .ct-eva-title {
      margin-top: 0.96rem;
      font-size: 0.4rem;
      line-height: 0.57rem;
      text-align: center;
    }

    .ct-eva-content {
      margin-top: 0.96rem;
      width: 6.86rem;
      background: #fff;
      padding: 0.32rem;
      font-size: 0.24rem;
      line-height: 0.48rem;
      display: flex;
      box-shadow: 0 0.2rem 0.6rem 0 rgba(102, 102, 102, 0.08);
      border-radius: 0.16rem;

      img {
        width: 1.6rem;
        height: 1.6rem;
      }

      .eva-description {
        margin-left: 0.32rem;
        display: flex;
        flex-direction: column;
        font-size: 0.24rem;
        line-height: 0.48rem;
        text-align: left;
      }

      .eva-desc-title {
        font-weight: 500;
      }

      .eva-desc-content {
        font-weight: 400;
      }
    }
  }

}

@media screen and (max-width: 1200px) {
  .module-card-box .box img {
    width: 300px;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .module-card-box .box img {
    width: calc(100vw / 4);
  }
}

@media screen and (min-width: 1920px) {
  .module-card-box .box img {
    width: 480px;
  }
}

.app {
  .home {
    .data-list-top {
      background: rgba(20, 114, 255, 0.04);
      display: flex;
      flex-wrap: wrap;

      .data-item {
        width: 50%;
        height: 1.64rem;
        text-align: center;
        color: #1472ff;

        .data-item_content {
          font-size: 0.24rem;
          padding: 0.36rem 0 0.08rem;
        }

        .data-text {
          font-size: 0.32rem;
          font-weight: 600;

          .data {
            font-size: 0.48rem;
          }
        }
      }
    }

    .module-flow-box.module-box {
      padding-bottom: 1.28rem;

      img {
        max-width: 100%;
        margin-top: 0;
      }
    }

    .module-card-box {
      height: auto;

      .box {
        display: block;
      }

      .item {
        position: relative;
        padding: 1.28rem 0.32rem;
        text-align: left;
        height: auto;

        .name {
          position: relative;
          font-size: 0.56rem;
          line-height: 0.72rem;
          font-weight: 600;
        }

        .text {
          max-width: none;
          font-size: 0.28rem;
          line-height: 0.44rem;
          padding: 0.32rem 0 0.96rem;
        }

        .link-box {
          position: absolute;
          top: 1.28rem;
          right: 0.32rem;
          font-size: 0.32rem;
          color: #fff;
          line-height: 0.72rem;

          a {
            font-size: inherit;
          }
        }

        img {
          max-width: 54.1% !important;
          width: auto;
          display: block;
          margin: auto;
        }
      }
    }

    .module-link-box {
      padding-bottom: 1.08rem !important;

      .items-box {
        margin-top: 0;
        display: block;

        .single {
          &::after {
            content: "";
            display: block;
            clear: both;
          }

          .title {
            text-align: center;
            font-size: 0.4rem;
            font-weight: 600;
            padding: 0 0 0.5rem;
          }

          .item {
            width: 50%;
            margin: 0;
            padding-bottom: 0.48rem;
            float: left;

            img {
              width: auto;
              max-width: 0.64rem;
            }

            div {
              .name {
                font-size: 0.3rem;
                font-weight: 600;
              }

              .des {
                font-size: 0.24rem;
                color: #999;
                line-height: 0.36rem;
              }
            }
          }
        }
      }
    }

    .module-plan-box {
      padding-bottom: 1.28rem !important;

      .box {
        display: flex;
        overflow: auto;

        .item {
          .tab {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 6rem;
            height: 2.88rem;
            padding-left: 0.8rem;
            background: url(~@/assets/images/app1.png) no-repeat rgba(20, 114, 255, 0.04);
            background-size: cover;
            text-align: left;
            border-radius: 0.16rem;
            margin-left: 0.2rem;

            &:nth-child(1) {
              margin-left: 0.32rem;
            }

            .tabName {
              font-size: 20px;
              font-weight: 600;
            }

            .text {
              font-size: 0.28rem;
              padding: 0.16rem 0 0.32rem;
            }

            a {
              color: #1472ff;
              font-size: 0.28rem;
            }
          }

          img {
            max-width: 100%;
          }
        }
      }
    }

    .module-service-box {
      .s-title {
        padding-bottom: 0.48rem;
        font-size: 0.24rem;
      }
    }
  }

  .home .banner-box .big-swiper {
    height: 9.6rem;

    .swiper-item {
      min-width: auto;
      height: 100%;
      background-size: cover;
    }
  }

  .lz-banner3 {
    width: auto;
    display: block;
    height: 100%;
    text-align: center;

    .title {
      padding: 1.6rem 0 0.24rem;
      font-size: 0.8rem;
      font-weight: 500;
      letter-spacing: 0.04rem;
    }

    .big_title {
      padding: 1.6rem 0.32rem 0.24rem;
      font-size: 0.56rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }

    p {
      margin-bottom: 0.96rem;
      letter-spacing: 0.02rem;
      font-size: 16px;
      font-weight: 500;
    }

    .lz-banner-btns {
      display: flex;
      justify-content: center;
    }
  }

  .btn-group {
    display: flex;
    justify-content: center;

    .btn_bwb,
    .btn_wwb {
      border-radius: 0.44rem;
      background: #fff;
    }

    .btn_wwb {
      padding: 0.14rem 0.64rem;
      border: 0.02rem solid #fff;
      font-size: 0.28rem;
    }

    .video-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 0.46rem;
      width: 3.2rem;
      height: 0.8rem;
      background: rgba(255, 255, 255, 0.12);
      border-radius: 0.44rem;
      border: 0.04rem solid #fff;
      color: #fff;
      cursor: pointer;
      font-size: 0.32rem;

      img {
        margin-right: 0.12rem;
        width: 0.48rem;
      }
    }

    .first-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 0;
      padding-bottom: 0;
      font-size: 0.32rem;
    }
  }

  .home .module-service-box {
    padding-bottom: 0.8rem;

    .top {
      display: block;
    }

    .icon-text {
      img {
        width: 1.12rem;
      }

      div {
        max-width: none;
        flex: 1;
        padding-left: 0.32rem;
        text-align: left;

        p {
          font-size: 0.32rem;
          padding-top: 0.16rem;
        }
      }

      .s-title {
        font-size: 0.24rem;
        padding: 0.08rem 0 0;
      }
    }

    .desc {
      text-align: left;
      font-size: 0.28rem;
      color: #666;
      padding: 0.48rem 0 0;
      background: none;
    }

    .bottom {
      display: block;

      .s-title {
        font-size: 0.2rem;
        padding: 0.08rem 0 0.6rem;
      }

      div p {
        font-size: 0.24rem;
      }
    }
  }

  .home .data-content {
    padding-top: 1.28rem;

    .data-title {
      font-size: 0.58rem;
      font-weight: 600;
      line-height: 0.72rem;
      margin-bottom: 0;
    }

    .data-list {
      width: auto;
      padding: 0.96rem 0.32rem 0;
      margin-bottom: 0;
      flex-wrap: wrap;

      .data-item {
        width: 3.26rem;
        margin-bottom: 0.32rem;
        text-align: center;

        .data-item_content {
          font-size: 0.24rem;
        }

        .data-text {
          font-size: 0.32rem;
          font-weight: 500;

          .data {
            font-size: 0.48rem;
          }
        }
      }
    }

    .data-tip {
      font-size: 0.24rem;
      padding-bottom: 1.24rem;
      margin-bottom: 0;
    }

    .title-icon {
      width: auto;
      padding: 0;

      .icon-item {
        width: 33.33%;
        margin-bottom: 0.8rem;

        img {
          width: 0.96rem;
          margin-bottom: 0.26rem;
        }
      }
    }
  }

  .home .module-choice-box {
    .box {
      display: flex;
      overflow: scroll;
      padding-top: 0.96rem;

      .item {
        width: 5.66rem;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        background: #fff;
        padding: 0.48rem 0.32rem;
        margin-right: 0.32rem;
        border-radius: 0.32rem;

        .text-box {
          height: 4rem;

          .text {
            font-size: 0.3rem;
            font-weight: 600;
            line-height: 0.44rem;
            text-align: left;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 8;
            -webkit-box-orient: vertical;
          }
        }

        .bottom .name {
          font-size: 0.3rem;
        }

        .bottom img {
          height: 0.72rem;
          margin-top: 0.2rem;
        }
      }
    }
  }

  .home .case-list {
    background: rgba(20, 114, 255, 0.04);
    padding-bottom: 1.12rem;

    .s-title {
      padding: 0.16rem 0 0.44rem;
    }

    .list-box {
      width: auto;
      padding-top: 0;

      .case {
        width: 2.08rem;
        height: auto;
        background: #fff;
        margin-bottom: 0.32rem;
        border-radius: 0.16rem;

        .img-box {
          height: 1.4rem;
          overflow: hidden;
        }

        p {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.3rem;
          height: 0.88rem;
          line-height: 0.44rem;
          padding: 0 0.2rem;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }

    .link-box {
      margin-top: 0.16rem;
    }
  }
}

.brand-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 100px;

  .logo-box {
    img {
      width: 80px;
      height: 80px;
      margin-right: 30px;
    }
  }
}



.com-link-btn {
  position: relative;
  width: 88px;
  height: 88px;
  overflow: hidden;
  border-radius: 50%;
  cursor: pointer;
  background-color: #fff;
  background-color: #1472ff;
  margin-top: 40px;
}

.brand-title {
  font-size: 28px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
}

.com-link-btn:hover .left {
  // background:blue;
  // border-radius: 50%;
  -webkit-animation: left2Center 0.5s ease-in-out;
  animation: left2Center 0.5s ease-in-out;
}

.com-link-btn:hover .right {
  -webkit-animation: center2Right 0.5s ease-in-out;
  animation: center2Right 0.5s ease-in-out;
}

.com-link-btn .el-icon-right {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 38px;
  font-weight: 700;
  // color: #000;
  color: #FFF;
}

.com-link-btn .el-icon-right.left {
  /* left:-20%; */
}

@-webkit-keyframes left2Center {
  0% {
    left: -20%;
  }

  to {
    left: 50%;
  }
}

@keyframes left2Center {
  0% {
    left: -20%;
  }

  to {
    left: 50%;
  }
}

@-webkit-keyframes center2Right {
  0% {
    left: 50%;
  }

  to {
    left: 120%;
  }
}

@keyframes center2Right {
  0% {
    left: 50%;
  }

  to {
    left: 120%;
  }
}
</style>
